import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { RetailMembershipsControllerModule } from './controllers/RetailMembershipsController';

export const RetailMembershipsView = angular
  .module('acme.view.application.retail.memberships', [
    uiRouter,
    'ui.bootstrap',
    RetailMembershipsControllerModule,
    'acme.view.application.dataGrid.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const retailMemberships = {
      name: 'application.retail.memberships',
      url: '/memberships?membershipId',
      views: {
        'subview-main': {
          controller: 'RetailMembershipsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/retail/memberships/memberships.tpl.html',
        },
      },
      data: {
        pageTitle: 'Memberships',
        permissions: ['MEMBERSHIP_SALES'],
      },
    };

    $stateProvider.state(retailMemberships);
  }).name;
